import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'

const PrivacyPolicy = () => {
  return (
    <> 

     <Header/>


    <div className=" container my-5 " style={{ borderBottom: '2px solid #DCDCDC', paddingTop:'90px' }}>
        <h1 className="text-center">Privacy Policy</h1>
        <p className="text-center mb-5">Last Updated on 24 March 2023</p>
    </div>
    <div className='container'>
        <div className='row'>
            <div className='col-lg-7 col-md-7 col-sm-12 pt-4 pb-5'>

                <h2 className='pb-3'>Effective Date: 24 March 2023</h2>
                <p style={{ color: '#343434' }}>
                    We RNS IT Solutions Private Limited, the provider of Intelli X 360, is committed to providing our users with high-quality services and ensuring their satisfaction with our platform. This Refund Policy outlines our policies and procedures regarding refunds for our SAAS-based platform for educational enterprises.
                </p>

                <h3 className='pt-4 pb-2'>1. Information We Collect</h3>

                <p><b>We may collect the following information from our users:</b></p>
                <ul>
                    <li>Provide and improve Intelli X 360's services and functionality.</li>
                    <li>Personalize the user experience by providing recommendations and insights based on usage data and educational information.</li>
                    <li>Communicate with users about their account, service updates, and marketing materials.</li>
                    <li>Respond to user support requests and feedback.</li>
                    <li>Analyze user behavior and usage patterns to improve the platform's performance and security.</li>
                    <li>Comply with legal requirements and enforce our policies and agreements.</li>
                </ul>

                <h3 className='pt-4 pb-4'>How We Use Information</h3>

                <p><b>We use the information we collect to:</b></p>
                <ul>
                    <li>Provide and improve Intelli X 360's services and functionality.</li>
                    <li>Personalize the user experience by providing recommendations and insights based on usage data and educational information.</li>
                    <li>Communicate with users about their account, service updates, and marketing materials.</li>
                    <li>Respond to user support requests and feedback.</li>
                    <li>Analyze user behavior and usage patterns to improve the platform's performance and security.</li>
                    <li>Comply with legal requirements and enforce our policies and agreements.</li>
                </ul>

                <h3 className='pt-4 pb-2'>How We Share Information</h3>

                <p>We may share information with third-party service providers that help us deliver our services, such as hosting providers and customer support platforms. We do not share information with educational institutions that use Intelli X 360 in any format without prior written consent of the information provider.</p>
                <p>We may also disclose information to comply with legal obligations or enforce our policies and agreements, or to protect the rights, property, or safety of ourselves or others.</p>


                <h3 className='pt-2 pb-2'>How We Protect Information</h3>

                <p className='my-3'>We take appropriate technical and organizational measures to protect user information from unauthorized access, disclosure, alteration, or destruction. We limit access to information to employees and contractors who have a legitimate need to access it.</p>

                <h4 className='pt-3 pb-2'>User Choices and Rights</h4>

                <p>Users have the right to access, update, and delete their personal information. They may also opt-out of marketing communications by following the unsubscribe instructions included in those communications.</p>


                <h4 className='pt-3 pb-4'>Changes to this Privacy Policy</h4>
                <p className='pt-2 pb-2'>We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations. Users will be notified of any material changes and asked to review and accept the new terms before continuing to use Intelli X 360.</p>

                <h4 className='pt-2 pb-2'>Contact Us</h4>
                <p>If you have any questions or concerns about this Privacy Policy, please contact us at help@intellix360.com .</p>
                <p>Plot No. 197, 101-103, Chanda tower, Main Gandhi Path Road, Jaipur-302021</p>

            </div>
        </div>
    </div> 


    <section>
     <Footer/>
    </section>
</>
  )
}

export default PrivacyPolicy
